import "./index.css";
import { Link } from "react-router-dom";
import MenuNavegacionMobile from "@componentes/MenuNavegacion/MenuNavegacionMobile/MenuNavegacionMobile";
import { useState, useEffect } from "react";
export default function CabeceraMobile() {
  const [cabecera, setCabecera] = useState("/logo-magenta.png");

  useEffect(() => {
    // Cargar el config.json desde la carpeta public
    const loadConfig = async () => {
      try {
        const response = await fetch("/config.json");
        const config = await response.json();
        setCabecera(config.LOGO_AYUNTAMIENTO);
      } catch (error) {
        console.error("Error loading config:", error);
      }
    };

    loadConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="encabezado-main-mobile">
      <div className="encabezado-mobile">
        <div className="logos-izquierda-mobile">
          <Link className="link-cabecera-mobile" to="/">
            <img
              src={cabecera}
              className="encabezado-image-mobile pequeno"
              alt="Logo Ayuntamiento"
            />
          </Link>
        </div>

        <div className="menu-navegacion-mobile">
          <MenuNavegacionMobile />
        </div>
      </div>
    </div>
  );
}
